import HorizontalLarge from './HorizontalLarge';
import HorizontalMedium from './HorizontalMedium';
import HorizontalMediumAlt from './HorizontalMediumAlt';
import HorizontalSmall from './HorizontalSmall';
import HorizontalSmallAlt from './HorizontalSmallAlt';

import TitleSmallDouble from './TitleSmallDouble';
import TitleMedium from './TitleMedium';
import TitleMediumTilted from './TitleMediumTilted';
import TitleMediumDouble from './TitleMediumDouble';
import TitleLarge from './TitleLarge';

import YearBox1 from './YearBox1';
import YearBox2 from './YearBox2';
import YearBox3 from './YearBox3';

import FooterTopLine from './FooterTopLine';
import FooterBottomLine from './FooterBottomLine';

import VerticalMedium from './VerticalMedium';

import Plaster from './Plaster';

export const footerLines = {
    top: FooterTopLine,
    bottom: FooterBottomLine,
};

export const borderTitle = {
    small: TitleSmallDouble,
    medium: TitleMedium,
    mediumTilted: TitleMediumTilted,
    mediumDouble: TitleMediumDouble,
    large: TitleLarge,
};

export const borderNotebook = {
    small: HorizontalSmallAlt,
    medium: HorizontalSmall,
    mediumTilted: HorizontalSmall,
    mediumDouble: HorizontalSmallAlt,
    large: TitleMedium,
};

export const yearBox = {
    yearBox1: YearBox1,
    yearBox2: YearBox2,
    yearBox3: YearBox3,
};

export default {
    horizontal: {
        small: HorizontalSmall,
        'small-alt': HorizontalSmallAlt,
        medium: HorizontalMedium,
        'medium-alt': HorizontalMediumAlt,
        large: HorizontalLarge,
        'large-alt': HorizontalLarge,
    },

    vertical: {
        small: VerticalMedium,
        'small-alt': VerticalMedium,
        medium: VerticalMedium,
        'medium-alt': VerticalMedium,
        large: VerticalMedium,
        'large-alt': VerticalMedium,
    },

    plaster: Plaster,
};
